import URLS from '../config/urls';
import BaseAPI from './BaseApi';


class ReportEvaluationsService {
    async getList(params: any): Promise<any> {
        try {
            const response = await BaseAPI.get(`${URLS.REPORT_EVALUATIONS}`, { params });
            return response; // Retorna a resposta da API
        } catch (e) {
            return { error: "Erro ao trazer listagem" }; // Retorna um objeto de erro
        }
    }
}

const reportEvaluationsService = new ReportEvaluationsService();
export default reportEvaluationsService;

